import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(availabilityStyles, {
    availability: {
        container: {
            css: css`
                overflow: hidden;
                margin: 0 0 20px;

                ${GridOffset} {
                    width: 100% !important;
                }

                ${GridItemStyle} {
                    overflow-x: auto;
                }
            `,
        },
        messageGridItem: {
            css: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [
                            {
                                values: ["20px 0 !important", null, "10px 0 20px !important", null, null],
                                properties: ["margin"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
    },
});
